$(document).ready(function() {
    $('.testimonial-slider').slick({
        autoplay:true,
        //autoplaySpeed: 1000,
        autoplaySpeed: 3000, // Changed from 1000 to 3000 (3 seconds)
        speed: 600,
        draggable: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
            }
        ]
    });
});